import AllRoutes from "routes/Routes";
import { ScrollToTop } from "react-router-scroll-to-top";
import WithAuthentication from "context/Authentication/WithAuthentication.tsx";
import { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import CartModal from "common/order/CartModal";
import WithAuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import React, { useContext, useState, useEffect } from "react";
import { CartItemsProvider } from "context/CardItemsProvider";
import withClearCache from "hoc/WithClearCache";
import useWindowSize from "./hooks/useWindowSize";
import Header from "./components/header/Header/Header.jsx";
import MobileHeader from "./components/header/MobileHeader/MobileHeader.jsx";
import Footer from "./components/footer/Footer.jsx";
import { ProductContextProvider } from "./context/ProductContext/ProductDataContext.jsx";
import WithWebInfo from "./context/WebInfo/WithWebInfo.tsx";
import ManagementContext, {
  ManagementContextProvider,
} from "context/WebInfo/ManagementContext";
import { CardItemContextProvider } from "context/CardItem/CardItemContext";

import DropList from "pages/DropList";
import useAxios from "services/useAxios.tsx";
import "pages/Svh/svh.css";

const ClearCacheComponent = withClearCache(MainApp);

function MainApp() {
  const auth = useContext(WithAuthenticationContext);

  const { execute: getConfigApi } = useAxios("api/get_config");
  const [backdrop, setBackdrop] = useState(false);
  const [categories, setCategories] = useState([]);

  const { width } = useWindowSize();

  const winSize = useWindowSize();

  useEffect(() => {
    getConfigApi({ config_name: "main_category" }).then((res) => {
      setCategories(res?.data);
    });
  }, []);
  console.log("categoriesList", categories);

  return (
    <div className="App">
      <WithAuthentication>
        <WithWebInfo>
          <ProductContextProvider>
            <CartItemsProvider>
              <CardItemContextProvider>
                <ManagementContextProvider>
                  <Toaster />
                  <ReactTooltip />
                  <ScrollToTop />
                  {/* <Header backButtonPressed={backButtonPressed}></Header> */}
                  {/* <Header2/> */}
                  <div id="header-container">
                    {winSize.width > 1040 ? (
                      <Header
                        back={backdrop}
                        active={setBackdrop}
                        categoriesList={categories}
                      />
                    ) : (
                      <MobileHeader categoriesList={categories} />
                    )}
                  </div>
                  {auth.userInfo.userType == 1 && <CartModal />}

                  {/*<AllRoutes></AllRoutes>*/}
                  {/*/!* <FooterSvh> *!/*/}
                  {/*<div*/}
                  {/*  style={{*/}
                  {/*    position: "fixed",*/}
                  {/*    bottom: winSize.width > 991 ? 20 : 40,*/}
                  {/*    left: 20,*/}
                  {/*    zIndex: 1000,*/}
                  {/*  }}*/}
                  {/*>*/}
                  {/*  <DropList />*/}
                  {/*</div>{" "}*/}
                  {/*<Footer>/!* <Mobile /> *!/</Footer>*/}
                  {/*/!* </FooterSvh> *!/*/}

                  <div
                    className={`${backdrop == true && "backdrop-bg"}`}
                    onClick={() => setBackdrop(false)}
                  >
                    <AllRoutes />
                    <Footer />
                  </div>
                  <div
                    style={{
                      position: "fixed",
                      bottom: width > 991 ? 20 : 80,
                      left: 20,
                      zIndex: 1000,
                    }}
                  >
                    <DropList />
                  </div>
                </ManagementContextProvider>
              </CardItemContextProvider>
            </CartItemsProvider>{" "}
          </ProductContextProvider>
        </WithWebInfo>
      </WithAuthentication>
    </div>
  );
}

function App() {
  return <ClearCacheComponent />;
}

export default App;
